<script setup>
import { useConfigStore } from '@core/stores/config'

const configStore = useConfigStore()
</script>

<template>
  <VProgressLinear
    v-if="configStore.showAppLoadingIndicator"
    color="primary"
    height="3"
    indeterminate
    class="position-fixed w-100 top-0 left-0"
    style="z-index: 9999"
  />
</template>
